import useSWR from 'swr';

import { fetchTemplates, type RecurringTemplate } from '../data/recurringRepository.js';

export const TEMPLATES_KEY = 'recurring-templates';

export type TemplatesState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | {
      status: 'ready';
      templates: readonly RecurringTemplate[];
      refresh: () => Promise<unknown>;
    };

export function useTemplates(): TemplatesState {
  const { data, error, isLoading, mutate } = useSWR<readonly RecurringTemplate[], Error>(
    TEMPLATES_KEY,
    fetchTemplates,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được danh sách khoản định kỳ.',
      retry: () => {
        void mutate();
      },
    };
  }
  if (isLoading || data === undefined) return { status: 'loading' };

  return { status: 'ready', templates: data, refresh: () => mutate() };
}
